import React from "react";

import ExpanderInteractive from "./expander-interactive";
import ExpanderRenderer from "./expander-renderer";

interface AccordionHeader {
  text: string;
  "mgnl:template": string;
  fontBold: boolean;
}

interface ExpanderItem {
  "mgnl:template": string;
  richText: string;
}

export interface AccordionData {
  accordionHeader: {
    [key: string]: AccordionHeader;
  };
  expanderItems: {
    [key: string]: ExpanderItem;
  };
  defaultExpanded?: boolean;
}

function Expander({
  accordionHeader,
  expanderItems,
  defaultExpanded,
}: Readonly<AccordionData>): React.JSX.Element {
  const renderer =
    Object.keys(expanderItems).length !== 0 ? (
      <ExpanderRenderer expanderItems={expanderItems["0"]} />
    ) : null;
  return (
    <ExpanderInteractive
      renderer={renderer}
      accordionHeader={accordionHeader["0"]}
      defaultExpanded={defaultExpanded}
    />
  );
}

export default Expander;
